import React from 'react'
import { useFormContext } from 'react-hook-form'
import Button from '../../../../ui/Button'
import { FormValues } from '../index'
import { parsePlanName, isCurrentPurchasedPlan, getPriceIdForPeriod } from '../utils'
import { Plan, PaymentPeriodType, PlanProduct } from '../../../../../lib/api/types/billing.interfaces'
import { CurrentUserObject } from '../../../../../lib/api/types/user.interfaces'

interface ModalActionsProps {
	currentPlan?: Plan
	currentUser?: CurrentUserObject
	modalPlans: PlanProduct[]
	isPending: boolean
	onCancel: () => void
	onConfirm: () => void
}

const ModalActions: React.FC<ModalActionsProps> = ({
	currentPlan,
	currentUser,
	modalPlans,
	isPending,
	onCancel,
	onConfirm,
}) => {
	const { watch } = useFormContext<FormValues>()
	const plan = watch('plan')
	const period = watch('period') as PaymentPeriodType

	const selectedModalPlan = modalPlans.find((item) => item.name === plan)
	const selectedPriceId = selectedModalPlan
		? getPriceIdForPeriod(selectedModalPlan.prices, period)
		: undefined

	const isTrial = Boolean(currentPlan?.trial)
	const isCurrentPlan = !isTrial && isCurrentPurchasedPlan(
		plan,
		period,
		currentPlan,
		selectedPriceId,
		currentUser?.plan?.priceId,
	)
	const isLockedPlan = currentUser?.organization?.id
		? plan === 'Free' || plan === 'Pro'
		: plan === 'Business' || plan === 'Enterprise'

	return (
		<div className="flex items-center justify-end mt-auto w-full gap-2">
			<Button label="Cancel" variant="tertiary" onClick={onCancel} />
			<Button
				tooltipOnDisabled
				disabled={(!isTrial && isCurrentPlan) || isLockedPlan || !selectedPriceId}
				tooltip={
					(!isTrial && isCurrentPlan)
						? 'This is your current purchased plan'
						: isLockedPlan
							? 'Choose a plan available for this account type'
							: !selectedPriceId
								? 'Pricing is unavailable for this plan and billing period'
								: null
				}
				label='Confirm'
				loading={isPending}
				onClick={onConfirm}
			/>
		</div>
	)
}

export default ModalActions
